import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import { getLocale, setLocale } from "./lib/i18n";
import "./styles/global.css";

setLocale(getLocale());

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
